let msg = {}
msg.install = function (Vue, options) {
    let _this = new Vue()
    Vue.prototype.msg = {
        info(msg) {
            _this.$message({
                message: msg,
                center: true,
                type: "info",
                showClose: true
            });
        },

        warn(msg) {
            _this.$message({
                message: msg,
                center: true,
                type: "warning",
                showClose: true
            });
        },

        success(msg) {
            _this.$message({
                message: msg,
                center: true,
                type: "success",
                showClose: true
            });
        },

        error(msg) {
            _this.$message({
                message: msg,
                center: true,
                type: "error",
                showClose: true,
                duration: 5000
            });
        }
    }
    
}
export default msg